import { BpmnModel, Expression, ExtensionCompletionConditionRuler, MexExpression } from '@edp-pmf/bpmn-model';
import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, Injector, ComponentFactoryResolver, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { DatagridComponent } from '@farris/ui-datagrid';
import { BsModalService } from '@farris/ui-modal';
import { TypeConverter } from '@farris/ide-property-panel';
import { MessagerService } from '@farris/ui-messager';
import { ExpressionService, InjectedType} from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';
import { MultiInstanceLoopCharacteristics } from './multi-instance-loop-characteristics.entity';
// import { ExtensionCompletionConditionRuler } from './extension-completion-condition-ruler/extension-completion-condition-ruler.entity';
import { SignRuleComponent } from '../sign-rule/sign-rule.component';
import { Condition, CounterSignRule, SemanticExpression } from '@gsp-wf/wf-process-model';
// import { SignRuleEntity } from '../sign-rule/entites/sign-rule.entity';
import { RTProcessInfo } from '../../model/rt-process-info';
import { switchMap } from 'rxjs/operators';
import { HttpService } from '@ecp-caf/caf-common';
import { of } from 'rxjs';
import { ProcessTime } from '../../model/process-time';
import { ResubmitEffect } from '../backward-rule/backward-rule.entity';

@Component({
  selector: 'lib-multi-instance-loop-characteristics',
  templateUrl: './multi-instance-loop-characteristics.component.html',
  styleUrls: ['./multi-instance-loop-characteristics.component.css'],
  providers: [
    WfLocalePipe,
 ]
})
export class MultiInstanceLoopCharacteristicsComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();


  @Input() set value(v) {
    this.loopCharacteristics = new MultiInstanceLoopCharacteristics();
    if (v) {
      this.loopCharacteristics.enable = v.enable;
      this.loopCharacteristics.sequential = v.sequential;
      this.preEnable = v.enable;
      this.preSequential = v.sequential;
      if(v.loopCardinality && (v.loopCardinality instanceof Expression) && ((v.loopCardinality).MexExpression)) {
        this.loopCharacteristics.loopCardinality = ((v.loopCardinality).MexExpression as SemanticExpression).Value;
        // this.loopCharacteristics.loopCardinality = this.peopleList;
      }
      if(v.completionConditionRules && v.completionConditionRules.length > 0) {
        let signRuleEntityArray:ExtensionCompletionConditionRuler[] = new Array<CounterSignRule>();
        for(let rule of v.completionConditionRules) {
            let signRule = new CounterSignRule(this.bpmnModel);
            signRule.ConclusionValue = rule.ConclusionValue;
            signRule.CalculateType = rule.CalculateType;
            signRule.ConditionValue = rule.ConditionValue;
            signRule.WaitAllVotes = rule.WaitAllVotes;
            if(!signRule.CompletionCondition) {
              signRule.CompletionCondition = new Condition(this.bpmnModel);
            }
            signRule.CompletionCondition.Value = rule.CompletionCondition ? rule.CompletionCondition.Value : null;
            signRuleEntityArray.push(signRule);
        }
        this.loopCharacteristics.completionConditionRules = signRuleEntityArray;
      }
    }
  }
  @Input() editorParams: any = {};
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('cell') cell: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;

  preEnable: boolean = false;

  preSequential: boolean = false;

  loopCharacteristics: MultiInstanceLoopCharacteristics = new MultiInstanceLoopCharacteristics();
  
  loopCharacteristicsTemp: MultiInstanceLoopCharacteristics = null;

  // peopleList: string;

  conditionRulesIsSet: string = this.localePipe.transform('multiInstanceLoopCharacteristics.conditionRulesSet');

  promptAct: boolean;
  
  bpmnModel: BpmnModel = this.uistate.bpmnModel;

  modalConfig = {
    title: this.localePipe.transform('multiInstanceLoopCharacteristics.loopCharacteristics'),
    width: 550,
    height: 450,
    showButtons: true
  };

  constructor(    
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private uistate: ProcessDesignerUIState,
    private expr: ExpressionService,
    private modalService: BsModalService,
    private message: MessagerService,
    private http: HttpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe) { 
      this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    }

  ngOnInit() {
    if(this.editorParams.location && this.editorParams.location == 'activity') {
      this.promptAct = true;
    }else {
      this.promptAct = false;
    }
  }

  loopCardinalityExpr(data: any){
    this.showloopCardinalityHelp(data);
  }

  showloopCardinalityHelp(data: string){
    this.showExpr();
    if (this.loopCharacteristics.loopCardinality) {
      this.expr.addExpressionText(this.loopCharacteristics.loopCardinality);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      // this.peopleList = expressionInfo;
      this.loopCharacteristics.loopCardinality = expressionInfo;
    });
  }

  showExpr(){
    // this.expr.clearContext();
    if (this.uistate.schemas.length > 0) {
      for (const schema of this.uistate.schemas) {
        // this.expr.addCommonObject(co);
        this.expr.addSchema('Schema', schema);
      }
      if (this.uistate.schemas[0].entityTypes && this.uistate.schemas[0].entityTypes.length > 0) {
        const entityType = this.uistate.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    const context = new Array();
    if (this.uistate.procInstContext.length > 0) {
      for (const variable of this.uistate.procInstContext) {
        context.push(variable);
        // this.expr.addContext(variable);
      }
    }
    if (this.uistate.processVariableContext.length > 0) {
      for (const variable of this.uistate.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
  }

  isEnable(data: any) {
    if(data) {
      if(this.uistate.propertyData.ClrTypeID === 'wf.UserActivity'
        && this.uistate.propertyData.BackWardRule
        && (this.uistate.propertyData.BackWardRule.ResubmitEffect === ResubmitEffect.backToMe || this.uistate.propertyData.BackWardRule.DynamicBackWardRuleAble)
      ) {
        this.message.info(this.localePipe.transform('multiInstanceLoopCharacteristics.enableForbid'), () => {
          if(this.loopCharacteristics) {
            this.loopCharacteristics.enable = false;
          }
        });
        return;
      }
    }
    if(!data) {
      this.loopCharacteristicsTemp = new MultiInstanceLoopCharacteristics();
      this.loopCharacteristicsTemp.enable = true;
      this.loopCharacteristicsTemp.sequential = this.loopCharacteristics.sequential;
      this.loopCharacteristicsTemp.loopCardinality = this.loopCharacteristics.loopCardinality;
      this.loopCharacteristicsTemp.completionConditionRules = new Array<CounterSignRule>();
      if(this.loopCharacteristics && this.loopCharacteristics.completionConditionRules) {
        this.loopCharacteristics.completionConditionRules.forEach(com => this.loopCharacteristicsTemp.completionConditionRules.push(com.clone() as any));
      } 
      this.loopCharacteristics = new MultiInstanceLoopCharacteristics();
    }else {
      if(this.loopCharacteristicsTemp) {
        this.loopCharacteristics.enable = true;
        this.loopCharacteristics.sequential = this.loopCharacteristicsTemp.sequential;
        this.loopCharacteristics.loopCardinality = this.loopCharacteristicsTemp.loopCardinality;
        this.loopCharacteristics.completionConditionRules = new Array<CounterSignRule>();
        if(this.loopCharacteristicsTemp.completionConditionRules) {
          this.loopCharacteristicsTemp.completionConditionRules.forEach(com => this.loopCharacteristics.completionConditionRules.push(com.clone() as any));
        }
        this.loopCharacteristicsTemp = null;
      }
    }
    this.validate(data);
    if(this.loopCharacteristics.completionConditionRules && this.loopCharacteristics.completionConditionRules.length > 0) {
      this.conditionRulesIsSet = this.localePipe.transform('multiInstanceLoopCharacteristics.conditionRulesSet');
    }else {
      this.conditionRulesIsSet = this.localePipe.transform('multiInstanceLoopCharacteristics.conditionRulesUnSet');
    }
  }

  validate(data: any) {
    if(data == true) {
      if(!this.loopCharacteristics.completionConditionRules || this.loopCharacteristics.completionConditionRules.length < 1) {
        this.setCompletionConditionRules(this.loopCharacteristics.completionConditionRules);
      }
    }
  }

  setCompletionConditionRules(completionConditionRules: ExtensionCompletionConditionRuler[]) {
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(SignRuleComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.value1 = completionConditionRules;
    // compRef.instance.data = this.loopCharacteristics.completionConditionRules;
    compRef.instance.submitModal.subscribe((re: ExtensionCompletionConditionRuler[]) => {
      this.loopCharacteristics.completionConditionRules = re;
      if(this.loopCharacteristics.completionConditionRules && this.loopCharacteristics.completionConditionRules.length > 0) {
        this.conditionRulesIsSet = this.localePipe.transform('multiInstanceLoopCharacteristics.conditionRulesSet');
      }else {
        this.conditionRulesIsSet = this.localePipe.transform('multiInstanceLoopCharacteristics.conditionRulesUnSet');
      }
      dialog.close();
    });
    compRef.instance.closeModal.subscribe((re: any) => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform("multiInstanceLoopCharacteristics.completionConditionRules"),
      width: 800,
      height: 515,
      buttons: compRef.instance.modalFooter1,
      showButtons: true
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }

  clickOK() {
    if(this.validateSave(this.loopCharacteristics)) {
      const object = { value: this.loopCharacteristics, parameters: null };
      if(this.preEnable != this.loopCharacteristics.enable || this.preSequential != this.loopCharacteristics.sequential) {
        const url = `/api/runtime/wf/v1.0/processInstances/runtimeActivityInstances?procDefId=${this.uistate.procDefId}&activityDefinitionId=${this.uistate.propertyData.Id}`;
        this.http.get(url).subscribe((re: any) => {
            if (this.uistate.time === ProcessTime.rt && re && re.length > 0) {
              this.message.info(this.localePipe.transform('multiInstanceLoopCharacteristics.checkPrompt'));
            }else {
              if(this.loopCharacteristics.enable && (!this.loopCharacteristics.completionConditionRules || this.loopCharacteristics.completionConditionRules.length == 0)) {
                this.message.info(this.localePipe.transform('multiInstanceLoopCharacteristics.completeSave'));
                return;
              }
              this.submitModal.emit(object);
            } 
          });
      }else {
        this.submitModal.emit(object);
      }
    }
  }
  clickCancel() {
    this.closeModal.emit();
  }

  validateSave(data:MultiInstanceLoopCharacteristics) {
    if(data && data.enable && (!data.loopCardinality || data.loopCardinality.length < 1)) {
      this.message.info(this.localePipe.transform('multiInstanceLoopCharacteristics.elementNotEmpty'));
      return false;
    }
    return true;
  }

}

export class MultiInstanceLoopCharacteristicsConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && (data as MultiInstanceLoopCharacteristics).enable) {
      return this.localePipe.transform('multiInstanceLoopCharacteristics.set');
    }
    return this.localePipe.transform('multiInstanceLoopCharacteristics.notSet');
  }
}
